/* eslint-disable */
import React, { Component } from 'react';
import {Button, Form,Popup,TextArea,Icon,Modal} from 'semantic-ui-react';
import InspectionContainer from "../../containers/inspection_container";
import {INSPECTION_API_URL} from "../../constants/api_routes"

class StatusUpdateForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStatus: undefined,
            updateSuccess: false,
            showExplanationDialog:false,
            refusalExplanation:"",
            showForm:false
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        if(this.state.selectedStatus){
            formData.append("status",this.state.selectedStatus);
            (this.props.startDate && this.props.endDate)? null: this.props.statusDateChange()
            this.props.changeStatus(INSPECTION_API_URL, formData, this.props.startDate? this.props.startDate: this.props.inspectionDate, this.props.endDate? this.props.endDate:this.props.inspectionDate);
            this.setState({updateSuccess: true});
        }
    };

    confirmRefusal=()=>{
          const formData = new FormData();
          formData.append("inspection_id",this.props.inspectionId)
          formData.append("reason",this.state.refusalExplanation)
           this.props.turnDownJob(INSPECTION_API_URL, formData,this.props.startDate? this.props.startDate: this.props.inspectionDate, this.props.endDate? this.props.endDate:this.props.inspectionDate)
           this.setState({showForm:false})
    }

    render() {

        const adminOptions = [
            {key: '6', type: 'input', text: '--Select Status--', value: undefined},
            {key: '0', type: 'input', text: 'Confirmed', value: 'confirmed'},
            {key: '1', type: 'input', text: 'Processing', value: 'processing'},
            // {key: '2', type: 'input', text: 'Request cancel', value: 'request_cancel'},
            // {key: '3', type: 'input', text: 'Request Abort', value: 'request_abort'},
            {key: '4', type: 'input', text: 'Cancelled', value: 'cancelled'},
            {key: '5', type: 'input', text: 'Aborted', value: 'aborted'},
            {key: '7', type: 'input', text: 'Scheduled', value: 'scheduled' },
            {key: '8', type: 'input', text: 'Submitted', value: 'submitted'},
        ];

        const clerkOptions = [
            {key: '6', type: 'input', text: '--Select Status--', value: undefined},
            {key: '0', type: 'input', text: 'Confirmed', value: 'confirmed'},
            {key: '1', type: 'input', text: 'Processing', value: 'processing'},
            // {key: '2', type: 'input', text: 'Request Abort', value: 'request_abort'},
        ];

        const agentOptions = [
            {key: '6', type: 'input', text: '--Select Status--', value: undefined},
            {key: '0', type: 'input', text: 'Request Abort', value: 'request_abort'},
        ];
        let options = [];
        switch (this.props.userRole) {
            case 'admin':
                options = adminOptions;
                break;
            case 'agent':
                options = agentOptions;
                break;
            case 'clerk':
                options = clerkOptions;
                break;
            default:
                options = clerkOptions;
        }
        let renderForm = () =>{
        return  <div className="pad-top">
                <Form onSubmit={this.handleSubmit}>
                    <Form.Group>
                        <input type='hidden' name='inspection_id' value={this.props.inspectionId}/>
                        <Form.Select options={options} placeholder='Select status' onChange={(e, data) => {
                            this.setState({selectedStatus: data.value})
                        }}/>
                        <Button primary disabled={!this.state.selectedStatus}> Change Status </Button>
                        </Form.Group>
                       { this.props.userRole === "clerk" && (
                            <div>
                                <hr/>
                          { !this.state.showExplanationDialog && this.props.currentStatus == "scheduled" &&  <Button negative onClick={(e)=>{e.preventDefault();this.setState({showExplanationDialog:true});}}>
                                Turn Down Job
                            </Button>}

                            {this.state.showExplanationDialog && (
                                <Form style={{marginTop:"0.5em"}}>
                                <Form.Field>
                                    <label>Reason for Refusal</label>
                                    <TextArea placeholder="Enter reason..." value={this.state.refusalExplanation} onChange={(e,{value})=>this.setState({refusalExplanation:value})}/>
                                </Form.Field>
                                <Button primary disabled={this.state.refusalExplanation.length<=5} onClick={()=>this.confirmRefusal()}>
                                    Confirm
                                </Button>
                                </Form>
                            )}
                            </div>
                        )}
                </Form>
            </div> 
    }
        return (<React.Fragment>
{ this.props.mobileView &&         <Button onClick={()=>{this.setState({showForm:true})}}icon circular compact basic className="format-capitalize" ><span     style={{ textTransform: 'capitalize' }}>{this.props.currentStatus}</span><Icon name="location arrow" ></Icon></Button>}

{this.state.showForm == true && <Modal
    open={this.state.showForm}
    size="small"
    closeOnDimmerClick={false}
>
    <Modal.Header>Change Status <Button  basic color="red"style={{float:"right"}}   onClick={() => this.setState({ showForm: false })} icon="close"></Button> </Modal.Header>

    <Modal.Content>{renderForm()}</Modal.Content></Modal>}
{!this.props.mobileView && <Popup trigger={<Button size="mini" className="format-capitalize"
                                             fluid> <span  style={{ textTransform: 'capitalize' }}>{this.props.currentStatus}</span></Button>} content={renderForm()}

                            position='left center'
                            on='click'
                            wide
                            header='Change status for Inspection'
                            flowing
                            hideOnScroll
></Popup>}  </React.Fragment>
        );
    }
}

export default InspectionContainer(StatusUpdateForm);




// WEBPACK FOOTER //
// ./src/views/inspection/change_status.js